// extracted by mini-css-extract-plugin
module.exports = {"InfoCard":"InfoCard_InfoCard__g1UhY","CardHead":"InfoCard_CardHead__3RhWq","trafficLights":"InfoCard_trafficLights__3_3My"};